import PositionCard from './PositionCard';

/**
 * Section that renders the full grid of open board positions.
 * @param {Array}  positions - Array of position objects
 * @param {string} deadline  - The dynamic deadline date string
 */
const PositionsGrid = ({ positions, deadline }) => (
  <section id="positions-grid" className="mb-24">
    {/* Section Header */}
    <div className="flex justify-between items-center mb-12">
      <div>
        <h2 className="text-3xl font-bold text-white mb-2">
          Open Board Positions
        </h2>
        <p className="text-gray-400 font-medium">
          Select the role that best matches your skills, experience, and passion.
        </p>
      </div>
      <span className="hidden sm:flex items-center gap-2 text-sm font-bold text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-4 py-2 rounded-full">
        {positions.length} Openings
      </span>
    </div>

    {/* Cards Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {positions.map((position, index) => (
        <PositionCard
          key={position.id || position.title}
          position={position}
          index={index}
          deadline={deadline}
        />
      ))}
    </div>
  </section>
);

export default PositionsGrid;
